import { useQuery } from "react-query";
import axios from "axios";
import Config from "../Config";

export const getComplaintsDashboard = async ({
  token,
  propertyId,
  locationId,
}) => {
  const params = new URLSearchParams({
    propId: String(propertyId ?? 0),
    locationId: String(locationId ?? 0),
  });

  const response = await axios.get(
    `${Config.apiUrl}/complaint/web/dashboard?${params}`,
    {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    }
  );

  if (response.data?.isSuccess === false) {
    throw new Error("Unable to fetch complaints overview");
  }

  return response.data;
};

export const useComplaintsOverview = ({
  token,
  propertyId,
  locationId,
}) => {
  return useQuery(
    [
      "complaintsDashboard",
      propertyId,
      locationId,
      token,
    ],
    () =>
      getComplaintsDashboard({
        token,
        propertyId,
        locationId,
      }),
    {
      enabled: Boolean(token),
      keepPreviousData: true,
      retry: 1,
    }
  );
};